import { render, staticRenderFns } from "./ProviderResetPassword.vue?vue&type=template&id=550d44a9&scoped=true"
import script from "./ProviderResetPassword.vue?vue&type=script&lang=js"
export * from "./ProviderResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ProviderResetPassword.vue?vue&type=style&index=0&id=550d44a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550d44a9",
  null
  
)

export default component.exports